import React from 'react';
import type { ChangeEvent } from 'react';
import type { TravelerFormValues } from '../../../../api/reservationInfo';
import type { TravelerFieldRules } from '../utils';

type Props = {
  travelerFieldRules: TravelerFieldRules;
  traveler: TravelerFormValues;
  travelerErrors: Partial<Record<keyof TravelerFormValues, string>>;
  onTextChange: (field: keyof TravelerFormValues) => (e: ChangeEvent<HTMLInputElement>) => void;
  disabled: boolean;
};

const ReservationInfoAirPassportFields = ({
  travelerFieldRules,
  traveler,
  travelerErrors,
  onTextChange,
  disabled
}: Props) => {
  const { isRequired, isVisible } = travelerFieldRules;
  if (!isVisible('passport_number') && !isVisible('passport_expire') && !isVisible('passport_issued_country')) {
    return null;
  }

  const styles = getStyles();

  return (
    <>
      {isVisible('passport_number') && (
        <div style={styles.formGroup}>
          <label htmlFor="traveler-passportNumber" style={styles.label}>
            パスポート番号
            {isRequired('passport_number') && <span style={styles.required}>*</span>}
          </label>
          <input
            id="traveler-passportNumber"
            type="text"
            style={{
              ...styles.input,
              ...(travelerErrors.passportNumber ? styles.inputError : {})
            }}
            value={traveler.passportNumber}
            onChange={onTextChange('passportNumber')}
            disabled={disabled}
          />
          {travelerErrors.passportNumber && <span style={styles.errorText}>{travelerErrors.passportNumber}</span>}
        </div>
      )}

      {isVisible('passport_expire') && (
        <div style={styles.formGroup}>
          <label htmlFor="traveler-passportExpire" style={styles.label}>
            パスポート有効期限
            {isRequired('passport_expire') && <span style={styles.required}>*</span>}
          </label>
          <input
            id="traveler-passportExpire"
            type="date"
            style={{
              ...styles.input,
              ...(travelerErrors.passportExpire ? styles.inputError : {})
            }}
            value={traveler.passportExpire}
            onChange={onTextChange('passportExpire')}
            disabled={disabled}
          />
          {travelerErrors.passportExpire && <span style={styles.errorText}>{travelerErrors.passportExpire}</span>}
        </div>
      )}

      {isVisible('passport_issued_country') && (
        <div style={styles.formGroup}>
          <label htmlFor="traveler-passportIssuedCountry" style={styles.label}>
            パスポート発行国
            {isRequired('passport_issued_country') && <span style={styles.required}>*</span>}
          </label>
          <input
            id="traveler-passportIssuedCountry"
            type="text"
            style={{
              ...styles.input,
              ...(travelerErrors.passportIssuedCountry ? styles.inputError : {})
            }}
            placeholder="例：日本"
            value={traveler.passportIssuedCountry}
            onChange={onTextChange('passportIssuedCountry')}
            disabled={disabled}
          />
          {travelerErrors.passportIssuedCountry && (
            <span style={styles.errorText}>{travelerErrors.passportIssuedCountry}</span>
          )}
        </div>
      )}
    </>
  );
};

const getStyles = (): Record<string, React.CSSProperties> => ({
  formGroup: {
    marginBottom: '16px'
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '6px',
    color: '#333'
  },
  required: {
    color: '#e74c3c',
    marginLeft: '4px'
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box' as const,
    outline: 'none'
  },
  select: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box' as const,
    outline: 'none',
    backgroundColor: '#fff',
    cursor: 'pointer'
  },
  inputError: {
    borderColor: '#e74c3c'
  },
  errorText: {
    color: '#e74c3c',
    fontSize: '12px',
    marginTop: '4px',
    display: 'block'
  }
});

export default ReservationInfoAirPassportFields;
